// extracted by mini-css-extract-plugin
export default {"wrapper":"EditOrganizationForm_wrapper__zEfnv","submitWrapper":"EditOrganizationForm_submitWrapper__GwI7N"};